export const translations = {
  en: {
    // Header & Navigation
    nav: {
      home: "Home",
      products: "Products",
      findByBike: "Find by Bike",
      about: "About",
      whereToBuy: "Where to Buy",
      blog: "Blog",
      contact: "Contact",
      shopNow: "Shop Now"
    },
    
    // Homepage
    home: {
      heroTitle: "The OffRoad Shop You've Always Dreamed Of",
      heroSubtitle: "Premium motocross accessories and performance parts engineered for durability, speed, and excellence.",
      shopAmazon: "Shop on Amazon",
      visitEbay: "Visit eBay Store",
      whyTitle: "Why Choose ALLMX",
      whyPerformance: "Peak Performance",
      whyPerformanceDesc: "Engineered for maximum performance. Every product tested in real-world conditions.",
      whyDurability: "Built to Last",
      whyDurabilityDesc: "Premium materials and construction ensure durability even in extreme conditions.",
      whyDelivery: "Fast Delivery",
      whyDeliveryDesc: "Quick shipping from Italy via trusted platforms. Get your gear when you need it.",
      featuredTitle: "Featured Products",
      featuredSubtitle: "Discover our most popular accessories and performance parts",
      viewAll: "View All Products",
      trustTitle: "Trusted by Riders",
      ctaTitle: "Ready to Upgrade Your Ride?",
      ctaSubtitle: "Browse our complete collection on Amazon and eBay. Fast shipping across Europe."
    },
    
    // Products Page
    products: {
      title: "Our Products",
      subtitle: "Premium motocross accessories and performance parts",
      filter: "Filter:",
      all: "All",
      accessories: "Accessories",
      performanceParts: "Performance Parts",
      gear: "Gear",
      amazon: "Amazon",
      ebay: "eBay"
    },
    
    // About Page
    about: {
      title: "About ALLMX",
      subtitle: "Driven by passion. Built for performance.",
      storyTitle: "Our Story",
      storyP1: "ALLMX was born from a deep passion for motocross and a commitment to excellence. Based in the heart of Palermo, Italy, we understand what riders need because we are riders ourselves.",
      storyP2: "Every product in our catalog has been carefully selected and tested in real-world conditions. We don't just sell accessories and performance parts—we provide solutions that enhance your riding experience and push the boundaries of what's possible on two wheels.",
      storyP3: "Our mission is simple: deliver premium-quality products that riders can trust, backed by the credibility and convenience of established marketplaces like Amazon and eBay.",
      valuesTitle: "What Drives Us",
      value1Title: "Performance First",
      value1Desc: "Every product is chosen for its ability to enhance performance. No compromises, no shortcuts—just parts that work when it matters most.",
      value2Title: "Quality Assurance",
      value2Desc: "We stand behind every product. Rigorous testing and quality control ensure that what you receive exceeds your expectations.",
      value3Title: "Rider Community",
      value3Desc: "We're part of the motocross community. Your feedback shapes our selection, and your success on the track is our greatest reward.",
      value4Title: "Italian Heritage",
      value4Desc: "Based in Palermo, Italy, we bring European quality and style to the world of motocross accessories and performance parts.",
      locationTitle: "Based in Palermo, Italy",
      locationDesc: "Operating from the beautiful city of Palermo, we serve riders across Europe and beyond through our Amazon and eBay stores.",
      stat1: "Products Sold",
      stat2: "Happy Customers",
      stat3: "Positive Ratings"
    },
    
    // Where to Buy Page
    whereToBuy: {
      title: "Where to Buy",
      subtitle: "Shop ALLMX products on trusted marketplaces",
      amazonTitle: "Amazon Store",
      amazonDesc: "Browse our complete collection on Amazon Italy with Prime shipping and trusted buyer protection.",
      ebayTitle: "eBay Store",
      ebayDesc: "Shop directly from our eBay Italy store with competitive prices and reliable shipping.",
      protection: "Buyer Protection",
      protectionAmazon: "Amazon A-to-Z Guarantee on all purchases",
      protectionEbay: "eBay Money Back Guarantee if item not as described",
      shipping: "Fast Shipping",
      shippingAmazon: "Prime delivery available across Italy",
      shippingEbay: "Tracked shipping across Europe",
      payment: "Secure Payment",
      paymentAmazon: "Multiple payment options, all secure",
      paymentEbay: "PayPal Protection for safe transactions",
      visitStore: "Visit Amazon Store",
      visitEbayStore: "Visit eBay Store",
      whyTitle: "Why Shop Through Marketplaces?",
      why1Title: "Trust & Security",
      why1Desc: "Both Amazon and eBay provide comprehensive buyer protection policies, ensuring your purchase is safe and secure.",
      why2Title: "Easy Returns",
      why2Desc: "Not satisfied? Return policies make it simple to get a refund or exchange through established marketplace processes.",
      why3Title: "Fast Delivery",
      why3Desc: "Benefit from the efficient logistics networks of major marketplaces for quick delivery to your door.",
      why4Title: "Customer Reviews",
      why4Desc: "Read authentic reviews from other customers to make informed decisions about your purchase.",
      ctaTitle: "Ready to Shop?",
      ctaSubtitle: "Choose your preferred marketplace and start browsing our premium products",
      shopAmazon: "Shop on Amazon",
      shopEbay: "Shop on eBay"
    },
    
    // Contact Page
    contact: {
      title: "Contact Us",
      subtitle: "Get in touch with the ALLMX team",
      formTitle: "Send us a Message",
      name: "Name",
      namePlaceholder: "Your name",
      email: "Email",
      emailPlaceholder: "your@email.com",
      subject: "Subject",
      subjectPlaceholder: "How can we help?",
      message: "Message",
      messagePlaceholder: "Your message...",
      send: "Send Message",
      infoTitle: "Contact Information",
      location: "Location",
      locationValue: "Palermo, Italy",
      emailLabel: "Email",
      support: "Support",
      supportValue: "Available through Amazon & eBay messaging",
      whatsapp: "WhatsApp",
      whatsappValue: "Chat with us (chat only)",
      successMessage: "Message sent! We will get back to you soon."
    },
    
    // Blog Page
    blog: {
      title: "ALLMX Blog",
      subtitle: "Expert tips, guides, and insights for motocross enthusiasts",
      search: "Search articles...",
      noResults: "No articles found. Try adjusting your search or filters.",
      managePosts: "Manage Blog Posts",
      readMore: "Read More",
      backToBlog: "Back to Blog",
      categories: {
        all: "All",
        accessories: "Accessories",
        performance: "Performance",
        maintenance: "Maintenance"
      }
    },
    
    // Blog Admin
    blogAdmin: {
      title: "Manage Blog Posts",
      createNew: "Create New Post",
      editPost: "Edit Post",
      createPost: "Create New Post",
      allPosts: "All Posts",
      formTitle: "Title",
      titlePlaceholder: "Post title",
      category: "Category",
      excerpt: "Excerpt",
      excerptPlaceholder: "Brief description...",
      content: "Content",
      contentPlaceholder: "Full article content...",
      image: "Image URL",
      imagePlaceholder: "https://...",
      update: "Update Post",
      create: "Create Post",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      deleteConfirm: "Are you sure you want to delete this post?",
      created: "Post created successfully!",
      updated: "Post updated successfully!",
      deleted: "Post deleted successfully!"
    },
    
    // Footer
    footer: {
      description: "Premium motocross accessories and performance parts. Based in Palermo, Italy.",
      quickLinks: "Quick Links",
      shop: "Shop",
      amazonStore: "Amazon Store",
      ebayStore: "eBay Store",
      newsletter: "Newsletter",
      newsletterDesc: "Subscribe for updates on new products and exclusive deals.",
      couponTitle: "Get 5% OFF Your First Order!",
      couponDesc: "Subscribe and receive an exclusive coupon code via email.",
      emailPlaceholder: "Your email",
      subscribe: "Subscribe",
      copyright: "© 2025 ALLMX. All rights reserved. Made in Palermo, Italy."
    },
    
    // Common
    common: {
      by: "by",
      author: "ALLMX Team",
      postNotFound: "Post Not Found"
    },

    // Toast Messages
    toast: {
      productAdded: "Product added to cart!",
      productRemoved: "Product removed from cart",
      cartCleared: "Cart cleared",
      stockUpdated: "Stock updated",
      orderDeleted: "Order deleted!",
      productDeleted: "Product deleted!",
      noChanges: "No changes to save",
      bulkUpdateSuccess: "products updated!",
      orderStatusUpdated: "Status updated",
      csvRequired: "Please select a CSV file",
      fileRequired: "Please select a file first",
      importSuccess: "Import successful!",
      error: "Error",
      errorConnection: "Connection error",
      errorLoading: "Error loading",
      errorUpdate: "Update error",
      errorDelete: "Delete error"
    }
  },
  
  it: {
    // Header & Navigazione
    nav: {
      home: "Home",
      products: "Prodotti",
      findByBike: "Trova per Moto",
      about: "Chi Siamo",
      whereToBuy: "Dove Acquistare",
      blog: "Blog",
      contact: "Contatti",
      shopNow: "Acquista Ora"
    },
    
    // Homepage
    home: {
      heroTitle: "Il negozio per l'OffRoad che hai sempre sognato",
      heroSubtitle: "Accessori premium e componenti per motocross progettati per durata, velocità ed eccellenza.",
      shopAmazon: "Acquista su Amazon",
      visitEbay: "Visita Store eBay",
      whyTitle: "Perché Scegliere ALLMX",
      whyPerformance: "Massime Prestazioni",
      whyPerformanceDesc: "Progettato per prestazioni massime. Ogni prodotto testato in condizioni reali.",
      whyDurability: "Costruito per Durare",
      whyDurabilityDesc: "Materiali premium e costruzione garantiscono durata anche in condizioni estreme.",
      whyDelivery: "Consegna Veloce",
      whyDeliveryDesc: "Spedizione rapida dall'Italia tramite piattaforme affidabili. Ricevi la tua attrezzatura quando ne hai bisogno.",
      featuredTitle: "Prodotti in Evidenza",
      featuredSubtitle: "Scopri i nostri accessori e componenti più popolari",
      viewAll: "Vedi Tutti i Prodotti",
      trustTitle: "Scelto dai Piloti",
      ctaTitle: "Pronto a Migliorare la Tua Moto?",
      ctaSubtitle: "Sfoglia la nostra collezione completa su Amazon ed eBay. Spedizione veloce in tutta Europa."
    },
    
    // Pagina Prodotti
    products: {
      title: "I Nostri Prodotti",
      subtitle: "Accessori premium e componenti per motocross",
      filter: "Filtra:",
      all: "Tutti",
      accessories: "Accessori",
      performanceParts: "Componenti",
      gear: "Equipaggiamento",
      amazon: "Amazon",
      ebay: "eBay"
    },
    
    // Pagina Chi Siamo
    about: {
      title: "Chi Siamo",
      subtitle: "Guidati dalla passione. Costruiti per le prestazioni.",
      storyTitle: "La Nostra Storia",
      storyP1: "ALLMX nasce da una profonda passione per il motocross e un impegno verso l'eccellenza. Con sede nel cuore di Palermo, Italia, capiamo cosa serve ai piloti perché siamo piloti noi stessi.",
      storyP2: "Ogni prodotto nel nostro catalogo è stato accuratamente selezionato e testato in condizioni reali. Non vendiamo solo accessori e componenti—offriamo soluzioni che migliorano la tua esperienza di guida e spingono i confini di ciò che è possibile su due ruote.",
      storyP3: "La nostra missione è semplice: fornire prodotti di qualità premium di cui i piloti possono fidarsi, supportati dalla credibilità e comodità di marketplace affermati come Amazon ed eBay.",
      valuesTitle: "Cosa Ci Guida",
      value1Title: "Prestazioni Prima di Tutto",
      value1Desc: "Ogni prodotto è scelto per la sua capacità di migliorare le prestazioni. Nessun compromesso, nessuna scorciatoia—solo componenti che funzionano quando conta.",
      value2Title: "Garanzia di Qualità",
      value2Desc: "Supportiamo ogni prodotto. Test rigorosi e controllo qualità garantiscono che ciò che ricevi superi le tue aspettative.",
      value3Title: "Comunità di Piloti",
      value3Desc: "Siamo parte della comunità motocross. Il tuo feedback forma la nostra selezione, e il tuo successo in pista è la nostra più grande ricompensa.",
      value4Title: "Eredità Italiana",
      value4Desc: "Con sede a Palermo, Italia, portiamo qualità e stile europeo nel mondo degli accessori e componenti per motocross.",
      locationTitle: "Con Sede a Palermo, Italia",
      locationDesc: "Operando dalla bellissima città di Palermo, serviamo piloti in tutta Europa e oltre attraverso i nostri store Amazon ed eBay.",
      stat1: "Prodotti Venduti",
      stat2: "Clienti Soddisfatti",
      stat3: "Valutazioni Positive"
    },
    
    // Pagina Dove Acquistare
    whereToBuy: {
      title: "Dove Acquistare",
      subtitle: "Acquista i prodotti ALLMX su marketplace affidabili",
      amazonTitle: "Store Amazon",
      amazonDesc: "Sfoglia la nostra collezione completa su Amazon Italia con spedizione Prime e protezione acquirente garantita.",
      ebayTitle: "Store eBay",
      ebayDesc: "Acquista direttamente dal nostro store eBay Italia con prezzi competitivi e spedizione affidabile.",
      protection: "Protezione Acquirente",
      protectionAmazon: "Garanzia Amazon dalla A alla Z su tutti gli acquisti",
      protectionEbay: "Garanzia eBay Rimborso se l'articolo non corrisponde",
      shipping: "Spedizione Veloce",
      shippingAmazon: "Consegna Prime disponibile in tutta Italia",
      shippingEbay: "Spedizione tracciata in tutta Europa",
      payment: "Pagamento Sicuro",
      paymentAmazon: "Molteplici opzioni di pagamento, tutte sicure",
      paymentEbay: "Protezione PayPal per transazioni sicure",
      visitStore: "Visita Store Amazon",
      visitEbayStore: "Visita Store eBay",
      whyTitle: "Perché Acquistare Tramite Marketplace?",
      why1Title: "Fiducia e Sicurezza",
      why1Desc: "Sia Amazon che eBay forniscono politiche complete di protezione acquirente, garantendo che il tuo acquisto sia sicuro e protetto.",
      why2Title: "Resi Facili",
      why2Desc: "Non soddisfatto? Le politiche di reso rendono semplice ottenere un rimborso o cambio attraverso i processi consolidati dei marketplace.",
      why3Title: "Consegna Veloce",
      why3Desc: "Beneficia delle efficienti reti logistiche dei principali marketplace per consegne rapide a casa tua.",
      why4Title: "Recensioni Clienti",
      why4Desc: "Leggi recensioni autentiche da altri clienti per prendere decisioni informate sul tuo acquisto.",
      ctaTitle: "Pronto per Acquistare?",
      ctaSubtitle: "Scegli il tuo marketplace preferito e inizia a sfogliare i nostri prodotti premium",
      shopAmazon: "Acquista su Amazon",
      shopEbay: "Acquista su eBay"
    },
    
    // Pagina Contatti
    contact: {
      title: "Contattaci",
      subtitle: "Mettiti in contatto con il team ALLMX",
      formTitle: "Inviaci un Messaggio",
      name: "Nome",
      namePlaceholder: "Il tuo nome",
      email: "Email",
      emailPlaceholder: "tua@email.com",
      subject: "Oggetto",
      subjectPlaceholder: "Come possiamo aiutarti?",
      message: "Messaggio",
      messagePlaceholder: "Il tuo messaggio...",
      send: "Invia Messaggio",
      infoTitle: "Informazioni di Contatto",
      location: "Posizione",
      locationValue: "Palermo, Italia",
      emailLabel: "Email",
      support: "Supporto",
      supportValue: "Disponibile tramite messaggistica Amazon & eBay",
      successMessage: "Messaggio inviato! Ti risponderemo presto."
    },
    
    // Pagina Blog
    blog: {
      title: "Blog ALLMX",
      subtitle: "Consigli esperti, guide e approfondimenti per gli appassionati di motocross",
      search: "Cerca articoli...",
      noResults: "Nessun articolo trovato. Prova a modificare la ricerca o i filtri.",
      managePosts: "Gestisci Articoli Blog",
      readMore: "Leggi di Più",
      backToBlog: "Torna al Blog",
      categories: {
        all: "Tutti",
        accessories: "Accessori",
        performance: "Prestazioni",
        maintenance: "Manutenzione"
      }
    },
    
    // Admin Blog
    blogAdmin: {
      title: "Gestisci Articoli Blog",
      createNew: "Crea Nuovo Articolo",
      editPost: "Modifica Articolo",
      createPost: "Crea Nuovo Articolo",
      allPosts: "Tutti gli Articoli",
      formTitle: "Titolo",
      titlePlaceholder: "Titolo articolo",
      category: "Categoria",
      excerpt: "Estratto",
      excerptPlaceholder: "Breve descrizione...",
      content: "Contenuto",
      contentPlaceholder: "Contenuto completo dell'articolo...",
      image: "URL Immagine",
      imagePlaceholder: "https://...",
      update: "Aggiorna Articolo",
      create: "Crea Articolo",
      cancel: "Annulla",
      delete: "Elimina",
      edit: "Modifica",
      deleteConfirm: "Sei sicuro di voler eliminare questo articolo?",
      created: "Articolo creato con successo!",
      updated: "Articolo aggiornato con successo!",
      deleted: "Articolo eliminato con successo!"
    },
    
    // Footer
    footer: {
      description: "Accessori premium e componenti per motocross. Con sede a Palermo, Italia.",
      quickLinks: "Link Rapidi",
      shop: "Acquista",
      amazonStore: "Store Amazon",
      ebayStore: "Store eBay",
      newsletter: "Newsletter",
      newsletterDesc: "Iscriviti per ricevere aggiornamenti su nuovi prodotti e offerte esclusive.",
      couponTitle: "Ricevi il 5% di SCONTO sul Primo Ordine!",
      couponDesc: "Iscriviti e ricevi un codice sconto esclusivo via email.",
      emailPlaceholder: "La tua email",
      subscribe: "Iscriviti",
      copyright: "© 2025 ALLMX. Tutti i diritti riservati. Fatto a Palermo, Italia."
    },
    
    // Comune
    common: {
      by: "di",
      author: "Team ALLMX",
      postNotFound: "Articolo Non Trovato"
    },

    // Messaggi Toast
    toast: {
      productAdded: "Prodotto aggiunto al carrello!",
      productRemoved: "Prodotto rimosso dal carrello",
      cartCleared: "Carrello svuotato",
      stockUpdated: "Stock aggiornato",
      orderDeleted: "Ordine eliminato!",
      productDeleted: "Prodotto eliminato!",
      noChanges: "Nessuna modifica da salvare",
      bulkUpdateSuccess: "prodotti aggiornati!",
      orderStatusUpdated: "Stato aggiornato",
      csvRequired: "Seleziona un file CSV",
      fileRequired: "Seleziona prima un file",
      importSuccess: "Importazione completata!",
      error: "Errore",
      errorConnection: "Errore di connessione",
      errorLoading: "Errore nel caricamento",
      errorUpdate: "Errore aggiornamento",
      errorDelete: "Errore eliminazione"
    }
  },

  es: {
    // Header & Navegación
    nav: {
      home: "Inicio",
      products: "Productos",
      findByBike: "Buscar por Moto",
      about: "Nosotros",
      whereToBuy: "Dónde Comprar",
      blog: "Blog",
      contact: "Contacto",
      shopNow: "Comprar Ahora"
    },
    
    // Página Principal
    home: {
      heroTitle: "La Tienda OffRoad que Siempre Soñaste",
      heroSubtitle: "Accesorios premium y componentes de motocross diseñados para durabilidad, velocidad y excelencia.",
      shopAmazon: "Comprar en Amazon",
      visitEbay: "Visitar Tienda eBay",
      whyTitle: "Por Qué Elegir ALLMX",
      whyPerformance: "Máximo Rendimiento",
      whyPerformanceDesc: "Diseñado para el máximo rendimiento. Cada producto probado en condiciones reales.",
      whyDurability: "Construido para Durar",
      whyDurabilityDesc: "Materiales premium y construcción garantizan durabilidad incluso en condiciones extremas.",
      whyDelivery: "Envío Rápido",
      whyDeliveryDesc: "Envío rápido desde Italia a través de plataformas confiables. Recibe tu equipo cuando lo necesites.",
      featuredTitle: "Productos Destacados",
      featuredSubtitle: "Descubre nuestros accesorios y componentes más populares",
      viewAll: "Ver Todos los Productos",
      trustTitle: "Elegido por Pilotos",
      ctaTitle: "¿Listo para Mejorar tu Moto?",
      ctaSubtitle: "Explora nuestra colección completa en Amazon y eBay. Envío rápido a toda Europa."
    },
    
    // Página Productos
    products: {
      title: "Nuestros Productos",
      subtitle: "Accesorios premium y componentes para motocross",
      filter: "Filtrar:",
      all: "Todos",
      accessories: "Accesorios",
      performanceParts: "Componentes",
      gear: "Equipamiento",
      amazon: "Amazon",
      ebay: "eBay"
    },
    
    // Página Nosotros
    about: {
      title: "Sobre Nosotros",
      subtitle: "Impulsados por la pasión. Construidos para el rendimiento.",
      storyTitle: "Nuestra Historia",
      storyP1: "ALLMX nace de una profunda pasión por el motocross y un compromiso con la excelencia. Con sede en el corazón de Palermo, Italia, entendemos lo que los pilotos necesitan porque nosotros mismos somos pilotos.",
      storyP2: "Cada producto en nuestro catálogo ha sido cuidadosamente seleccionado y probado en condiciones reales. No solo vendemos accesorios y componentes: ofrecemos soluciones que mejoran tu experiencia de conducción.",
      storyP3: "Nuestra misión es simple: ofrecer productos de calidad premium en los que los pilotos puedan confiar, respaldados por la credibilidad y comodidad de marketplaces como Amazon y eBay.",
      valuesTitle: "Lo Que Nos Impulsa",
      value1Title: "Rendimiento Primero",
      value1Desc: "Cada producto se elige por su capacidad para mejorar el rendimiento. Sin compromisos, sin atajos: solo piezas que funcionan cuando importa.",
      value2Title: "Garantía de Calidad",
      value2Desc: "Respaldamos cada producto. Pruebas rigurosas y control de calidad garantizan que lo que recibes supere tus expectativas.",
      value3Title: "Comunidad de Pilotos",
      value3Desc: "Somos parte de la comunidad motocross. Tu feedback forma nuestra selección, y tu éxito en la pista es nuestra mayor recompensa.",
      value4Title: "Herencia Italiana",
      value4Desc: "Con sede en Palermo, Italia, llevamos calidad y estilo europeo al mundo de los accesorios y componentes para motocross.",
      locationTitle: "Con Sede en Palermo, Italia",
      locationDesc: "Operando desde la hermosa ciudad de Palermo, servimos a pilotos en toda Europa y más allá a través de nuestras tiendas Amazon y eBay.",
      stat1: "Productos Vendidos",
      stat2: "Clientes Satisfechos",
      stat3: "Valoraciones Positivas"
    },
    
    // Página Dónde Comprar
    whereToBuy: {
      title: "Dónde Comprar",
      subtitle: "Compra productos ALLMX en marketplaces de confianza",
      amazonTitle: "Tienda Amazon",
      amazonDesc: "Explora nuestra colección completa en Amazon Italia con envío Prime y protección al comprador garantizada.",
      ebayTitle: "Tienda eBay",
      ebayDesc: "Compra directamente en nuestra tienda eBay Italia con precios competitivos y envío fiable.",
      protection: "Protección al Comprador",
      protectionAmazon: "Garantía Amazon de la A a la Z en todas las compras",
      protectionEbay: "Garantía eBay Devolución si el artículo no corresponde",
      shipping: "Envío Rápido",
      shippingAmazon: "Entrega Prime disponible en toda Italia",
      shippingEbay: "Envío con seguimiento en toda Europa",
      payment: "Pago Seguro",
      paymentAmazon: "Múltiples opciones de pago, todas seguras",
      paymentEbay: "Protección PayPal para transacciones seguras",
      visitStore: "Visitar Tienda Amazon",
      visitEbayStore: "Visitar Tienda eBay",
      whyTitle: "¿Por Qué Comprar a Través de Marketplaces?",
      why1Title: "Confianza y Seguridad",
      why1Desc: "Tanto Amazon como eBay proporcionan políticas completas de protección al comprador, asegurando que tu compra sea segura.",
      why2Title: "Devoluciones Fáciles",
      why2Desc: "¿No satisfecho? Las políticas de devolución facilitan obtener un reembolso o cambio a través de los procesos del marketplace.",
      why3Title: "Entrega Rápida",
      why3Desc: "Benefíciate de las eficientes redes logísticas de los principales marketplaces para entregas rápidas a tu puerta.",
      why4Title: "Reseñas de Clientes",
      why4Desc: "Lee reseñas auténticas de otros clientes para tomar decisiones informadas sobre tu compra.",
      ctaTitle: "¿Listo para Comprar?",
      ctaSubtitle: "Elige tu marketplace preferido y empieza a explorar nuestros productos premium",
      shopAmazon: "Comprar en Amazon",
      shopEbay: "Comprar en eBay"
    },
    
    // Página Contacto
    contact: {
      title: "Contacto",
      subtitle: "Ponte en contacto con el equipo ALLMX",
      formTitle: "Envíanos un Mensaje",
      name: "Nombre",
      namePlaceholder: "Tu nombre",
      email: "Email",
      emailPlaceholder: "tu@email.com",
      subject: "Asunto",
      subjectPlaceholder: "¿Cómo podemos ayudarte?",
      message: "Mensaje",
      messagePlaceholder: "Tu mensaje...",
      send: "Enviar Mensaje",
      infoTitle: "Información de Contacto",
      location: "Ubicación",
      locationValue: "Palermo, Italia",
      emailLabel: "Email",
      support: "Soporte",
      supportValue: "Disponible a través de mensajería Amazon y eBay",
      whatsapp: "WhatsApp",
      whatsappValue: "Escríbenos por chat (solo chat)",
      successMessage: "¡Mensaje enviado! Te responderemos pronto."
    },
    
    // Página Blog
    blog: {
      title: "Blog ALLMX",
      subtitle: "Consejos expertos, guías e información para los apasionados del motocross",
      search: "Buscar artículos...",
      noResults: "No se encontraron artículos. Intenta modificar tu búsqueda o filtros.",
      managePosts: "Gestionar Artículos",
      readMore: "Leer Más",
      backToBlog: "Volver al Blog",
      categories: {
        all: "Todos",
        accessories: "Accesorios",
        performance: "Rendimiento",
        maintenance: "Mantenimiento"
      }
    },
    
    // Admin Blog
    blogAdmin: {
      title: "Gestionar Artículos Blog",
      createNew: "Crear Nuevo Artículo",
      editPost: "Editar Artículo",
      createPost: "Crear Nuevo Artículo",
      allPosts: "Todos los Artículos",
      formTitle: "Título",
      titlePlaceholder: "Título del artículo",
      category: "Categoría",
      excerpt: "Extracto",
      excerptPlaceholder: "Breve descripción...",
      content: "Contenido",
      contentPlaceholder: "Contenido completo del artículo...",
      image: "URL Imagen",
      imagePlaceholder: "https://...",
      update: "Actualizar Artículo",
      create: "Crear Artículo",
      cancel: "Cancelar",
      delete: "Eliminar",
      edit: "Editar",
      deleteConfirm: "¿Estás seguro de que quieres eliminar este artículo?",
      created: "¡Artículo creado con éxito!",
      updated: "¡Artículo actualizado con éxito!",
      deleted: "¡Artículo eliminado con éxito!"
    },
    
    // Footer
    footer: {
      description: "Accesorios premium y componentes para motocross. Con sede en Palermo, Italia.",
      quickLinks: "Enlaces Rápidos",
      shop: "Tienda",
      amazonStore: "Tienda Amazon",
      ebayStore: "Tienda eBay",
      newsletter: "Newsletter",
      newsletterDesc: "Suscríbete para recibir novedades sobre nuevos productos y ofertas exclusivas.",
      couponTitle: "¡Consigue un 5% de DESCUENTO en tu Primer Pedido!",
      couponDesc: "Suscríbete y recibe un código de descuento exclusivo por email.",
      emailPlaceholder: "Tu email",
      subscribe: "Suscribirse",
      copyright: "© 2025 ALLMX. Todos los derechos reservados. Hecho en Palermo, Italia."
    },
    
    // Común
    common: {
      by: "por",
      author: "Equipo ALLMX",
      postNotFound: "Artículo No Encontrado"
    },

    // Mensajes Toast
    toast: {
      productAdded: "¡Producto añadido al carrito!",
      productRemoved: "Producto eliminado del carrito",
      cartCleared: "Carrito vaciado",
      stockUpdated: "Stock actualizado",
      orderDeleted: "¡Pedido eliminado!",
      productDeleted: "¡Producto eliminado!",
      noChanges: "Sin cambios que guardar",
      bulkUpdateSuccess: "productos actualizados!",
      orderStatusUpdated: "Estado actualizado",
      csvRequired: "Selecciona un archivo CSV",
      fileRequired: "Selecciona primero un archivo",
      importSuccess: "¡Importación completada!",
      error: "Error",
      errorConnection: "Error de conexión",
      errorLoading: "Error al cargar",
      errorUpdate: "Error de actualización",
      errorDelete: "Error de eliminación"
    }
  }
};
